var FormatHelper = (function() {
	return {
		shortDate: shortDate,
		mmddyyDate: mmddyyDate
	};

	function shortDate(value) {
		return formatDate(value, 'MM/DD/YYYY');
	}

	function mmddyyDate(value) {
		return formatDate(value, 'MM/DD/YY');
	}

	function formatDate(value, format) {
		if (!value) {
			return null;
		}

		if (typeof value === 'string') {
			return value;
		}

		if (value instanceof Date && !isNaN(value)) {
			return moment(value).format(format);
		}

		return null;
	}
})();
